module.exports = __webpack_public_path__ + "static/media/be.3a4d9034.mp3";